import { Button, cn } from "@tellescope/design-system";
import { Plus } from "lucide-react";
import { BlockProps } from "../../../types";
import { useContentBlock } from "../../../hooks";
import { BlockHeader } from "../BlockHeader";
import { BlockContent } from "../BlockContent";
import { ContentRecordsList } from "./ContentRecordsList";
import { ShareContentForm } from "./ShareContentForm";
import { BlockEmptyState } from "../BlockEmptyState";

export const ContentBlock = ({
  onMaximize,
  alwaysShowButtons = false,
  className,
  contentClassName,
  ...rest
}: BlockProps) => {
  const {
    t,
    parsedInfo,
    enduser,
    showShareForm,
    openShareForm,
    closeShareForm,
    isEditingTitle,
    setIsEditingTitle,
    newTitle,
    setNewTitle,
    editMode,
    setEditMode,
    updateInfo,
    duplicateBlock,
    deleteBlock,
    toggleExpanded,
    expanded,
    blockLayout,
    canEditTitle,
    canCreateBlock,
    canDeleteBlock,
  } = useContentBlock({ ...rest, onMaximize, alwaysShowButtons, className });

  return (
    <div className={cn("group", className)}>
      <BlockHeader
        editMode={editMode}
        setEditMode={setEditMode}
        isEditingTitle={isEditingTitle}
        setIsEditingTitle={setIsEditingTitle}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        canEditTitle={canEditTitle}
        parsedInfo={parsedInfo}
        updateInfo={updateInfo}
        duplicateBlock={duplicateBlock}
        deleteBlock={deleteBlock}
        canCreateBlock={canCreateBlock}
        canDeleteBlock={canDeleteBlock}
        onMaximize={onMaximize}
        alwaysShowButtons={alwaysShowButtons}
        actions={
          editMode &&
          !showShareForm && (
            <Button
              iconOnly
              variant="ghost"
              size="sm"
              color="muted"
              hoverLabel={t("Share Content")}
              onClick={openShareForm}
            >
              <Plus />
            </Button>
          )
        }
      />

      <BlockContent
        editMode={editMode}
        setEditMode={setEditMode}
        expanded={expanded}
        layout={blockLayout}
        onToggleExpanded={() => toggleExpanded()}
        className={cn("flex flex-col", contentClassName)}
      >
        {!enduser ? (
          <div className="flex flex-1 items-center justify-center">
            <BlockEmptyState>{t("Loading content...")}</BlockEmptyState>
          </div>
        ) : showShareForm ? (
          <ShareContentForm contactId={enduser.id} onSubmit={closeShareForm} onCancel={closeShareForm} />
        ) : (
          <ContentRecordsList contact={enduser} />
        )}
      </BlockContent>
    </div>
  );
};
